import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-not-available',
  templateUrl: './not-available.component.html',
  styleUrls: ['./not-available.component.scss'],
  standalone: false,
})
export class NotAvailableDialogComponent {
  constructor(
    private dialog: MatDialogRef<NotAvailableDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {}
}
